<template>
  <HeadlineComponent>Passwort zurücksetzen</HeadlineComponent>
  <form class="form-horizontal" @submit.prevent="reset()">
    <div class="form-group">
      <label for="inputEmail">Email address</label>
      <input type="email" class="form-control" id="inputEmail" v-model="email" placeholder="E-Mail"
        :class="{ 'is-invalid': emailError }">
      <div class="invalid-feedback">
        Die E-Mailadresse ist nicht bekannt.
      </div>
    </div>
    <LoadingButton class="btn-primary" :loading="loading">Weiter</LoadingButton>
  </form>
</template>

<script>
import { mapActions } from "pinia";
import { useAlertsStore } from "../stores/alerts.js";
import userService from "../services/user.service.js";
import LoadingButton from "../components/LoadingButton.vue";
import HeadlineComponent from "../components/HeadlineComponent.vue";
import * as Sentry from '@sentry/vue';

export default {
  name: "RequestPasswordChangeView",
  components: { LoadingButton, HeadlineComponent },
  data() {
    return {
      email: '',
      loading: false,
      emailError: false
    }
  },
  mounted() {
    if (this.$route.query.email) {
      this.email = this.$route.query.email;
    }
  },
  methods: {
    ...mapActions(useAlertsStore, { addAlert: 'add' }),
    async reset() {
      this.loading = true;
      this.emailError = false;
      try {
        await userService.requestPasswordChange({ email: this.email });
        this.addAlert('success', 'Du bekommst eine E-Mail mit weiteren Infos, check your mail!');
      } catch (e) {
        if (e) {
          if (e.response && e.response.status == 404) {
            this.emailError = true
          } else {
            Sentry.captureException(e);
            this.addAlert('danger', "Es ist was unerwartetes schief gegangen..");
            window.scrollTo(0, 0);
          }
        }
      }
      this.loading = false;
    }
  }
}
</script>

<style scoped>
form {
  width: 100%;
  max-width: 330px;
  margin: 0 auto;
  padding: 15px;
}

.form-group {
  text-align: center;
}
</style>